import React from 'react';
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/icons/canopy.png";
import ThemeToggle from "../common/ThemeToggle";
import { VERSION_DISPLAY } from "../../config/version";

export default function Header() {
    const location = useLocation();
    const quickActionsPath = location.pathname === '/quick-actions' ? '/dashboard' : '/quick-actions';

    return (
        <div className="header-container">
            <div className="header-logo-container">
                <Link to="/dashboard">
                    <img className="header-logo-img" src={logo} alt="Canopy Logo"/>
                </Link>
                <Link to="/dashboard" className="header-link">
                    <p className="header-name">Canopy Systems</p>
                </Link>
            </div>
            <div className="header-right">
                <Link
                    to={quickActionsPath}
                    className="header-quick-actions-link"
                    aria-label="Quick Actions"
                    title="Quick Actions"
                >
                    <i className="ri-flashlight-line header-quick-actions-icon" aria-hidden="true" />
                    <span className="header-quick-actions-label-full">Quick Actions</span>
                    <span className="header-quick-actions-label-short">Actions</span>
                </Link>
                <ThemeToggle />
                <p className="header-paragraph" alt="App Version Number"><i>{VERSION_DISPLAY}</i></p>
            </div>
        </div>
    );
}